import { createFileRoute } from "@tanstack/react-router";
import { FinanceCategoryModals } from "@/components/finance-category/finance-category-modals";
import FinanceCategoryTable from "@/components/finance-category/finance-category-table";
import { Button } from "@/components/ui/button";
import useAppStore from "@/store";
import { Plus } from "lucide-react";
import { useTranslate } from "../../../hooks/use-translate";

export const Route = createFileRoute("/(dasboard)/finance/categories")({
  component: FinanceCategoriesPage,
});

function FinanceCategoriesPage() {
  const store = useAppStore();
  const { t } = useTranslate();

  return (
    <>
      <FinanceCategoryModals />
      <div className="max-w-7xl mx-auto">
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold"> {t("Finance categories")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_finance_category");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add category")}
          </Button>
        </header>
        <FinanceCategoryTable />
      </div>
    </>
  );
}
